import {Injectable} from '@angular/core'
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub} from '@generated-backend-types';
import EventCalendarContainer = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Calendar.EventCalendarContainer;

@Injectable({providedIn: 'root'})
export class EventCalendarService extends BaseApiEndpointService<EventCalendarContainer> {
  protected override endpoint = '/event-calendar';

  public modelToMultiSelectItem(m: EventCalendarContainer): ListItem & { model: EventCalendarContainer } {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    }
  }
}
